import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

type AssignTeamsSelectionFooterProps = {
    selectedCount: number;
    isPending: boolean;
    onCancel: () => void;
    onSave?: () => void;
    isSaveDisabled: boolean;
    cancelDataAutomation: string;
    saveDataAutomation: string;
    cancelButtonHtmlType?: "button" | "submit" | "reset";
    saveButtonHtmlType?: "button" | "submit" | "reset";
};

export const AssignTeamsSelectionFooter = ({
    selectedCount,
    isPending,
    onCancel,
    onSave,
    isSaveDisabled,
    cancelDataAutomation,
    saveDataAutomation,
    cancelButtonHtmlType = "button",
    saveButtonHtmlType = "button",
}: AssignTeamsSelectionFooterProps) => {
    const { translate } = useTranslate();
    const selectedCountLabel =
        selectedCount === 1
            ? translate("si.management.teams.users.bulk.selected_teams_count.singular", { count: selectedCount })
            : translate("si.management.teams.users.bulk.selected_teams_count.plural", { count: selectedCount });

    return (
        <Flex
            alignItems="center"
            justifyContent="space-between"
            gap="8px"
            flex={1}
        >
            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon["300"]}
            >
                {selectedCountLabel}
            </Text>
            <Flex gap="8px">
                <Button
                    type="flat"
                    buttonHtmlType={cancelButtonHtmlType}
                    onClick={onCancel}
                    isDisabled={isPending}
                    dataAutomation={cancelDataAutomation}
                >
                    {translate("si.common.button.cancel")}
                </Button>
                <Button
                    type="primary"
                    buttonHtmlType={saveButtonHtmlType}
                    onClick={onSave}
                    isDisabled={isSaveDisabled}
                    isLoading={isPending}
                    dataAutomation={saveDataAutomation}
                >
                    {translate("si.common.button.save")}
                </Button>
            </Flex>
        </Flex>
    );
};
